module.exports = __webpack_public_path__ + "static/1FT-5759c91321d3f7686da3d38d0b1db6d2.png";